import { DateTime } from 'luxon'

import { SubscriptionResponseDTO } from '@core/api/dtos/response/accounts/subscription'
import {
	Subscription,
	SubscriptionStatus,
} from '@core/api/entities/account/subscription'

import { SubscriptionItemMapper } from './subscriptionItemMapper'
import { SubscriptionPlanMapper } from './subscriptionPlanMapper'

export class SubscriptionMapper {
	static toEntity(dto: SubscriptionResponseDTO): Subscription {
		return Subscription.create({
			id: dto.id,
			accountId: dto.account_id,
			planId: dto.plan_id,
			startAt: DateTime.fromISO(dto.start_at),
			endAt: dto.end_at ? DateTime.fromISO(dto.end_at) : null,
			trialStartAt: dto.trial_start_at
				? DateTime.fromISO(dto.trial_start_at)
				: null,
			trialEndAt: dto.trial_end_at ? DateTime.fromISO(dto.trial_end_at) : null,
			firstBillingAt: dto.first_billing_at
				? DateTime.fromISO(dto.first_billing_at)
				: null,
			nextBillingAt: dto.next_billing_at
				? DateTime.fromISO(dto.next_billing_at)
				: null,
			periodCycle: dto.period_cycle,
			currency: dto.currency,
			poNumber: dto.po_number,
			poNumberRequired: dto.po_number_required,
			invoiceNotes: dto.invoice_notes,
			status: dto.status as SubscriptionStatus,
			total: dto.total,
			createdAt: dto.created_at ? DateTime.fromISO(dto.created_at) : undefined,
			updatedAt: dto.updated_at ? DateTime.fromISO(dto.updated_at) : undefined,
			hasLicenses: dto.has_licenses,
			items: dto.items ? SubscriptionItemMapper.toEntities(dto.items.data) : [],
			plan: dto.plan
				? SubscriptionPlanMapper.toEntity(dto.plan.data)
				: undefined,
		})
	}

	static toEntities(dtos: SubscriptionResponseDTO[]): Subscription[] {
		return dtos.map(this.toEntity)
	}
}
